import InternalRouter from 'navigation/pages/InternalRouter';
import store from 'store';
import Footer from 'components/footer/Footer';
import CheckoutPage from 'navigation/pages/CheckoutPage';
import { bindMethod } from 'helpers/bind';
import { forceArray } from 'navigation/component/Component';
import scroll from 'core/scroll';
import anime from 'animejs';
import mqStore from 'store/mqStore';
import ReturnsBreadcrumbs from './partials/ReturnsBreadcrumbs';
class Returns extends InternalRouter {
    initialized() {
        super.initialized();
        this.testStep(this.el);
    }
    getModulesMap() {
        return {
            ...super.getModulesMap(),
            breadcrumb: ['.returns-breadcrumb', ReturnsBreadcrumbs],
            footer: ['footer', Footer]
        };
    }
    getPageSelector() {
        return '.returns__step';
    }
    getDefaultPageClass() {
        return CheckoutPage;
    }
    shouldRouteInternally(el) {
        if (this.step >= 5)
            return false;
        const page = el.querySelector(this.getPageSelector());
        if (!page)
            return false;
        const step = page.getAttribute('data-step');
        if (step)
            return (+step) < 5;
    }
    testStep(el) {
        const page = el.querySelector(this.getPageSelector());
        if (!page)
            return;
        const step = page.getAttribute('data-step');
        if (step) {
            this.step = +step;
            store.returnsStep.set(+step);
        }
    }
    bindEvents(add = true) {
        super.bindEvents(...arguments);
        const method = bindMethod(add);
        forceArray(this.refs.asideToggle).forEach(button => button[method]('click', this.onAsideToggleClick));
        this.refs.asideOverlay[method]('click', this.onAsideOverlayClick);
    }
    onAsideToggleClick = (e) => {
        e.stopImmediatePropagation();
        e.stopPropagation();
        const opened = this.refs.asideContent.classList.contains('opened');
        this.refs.asideContent.classList.toggle('opened', !opened);
        this.toggleDrawer(!opened);
    };
    onAsideOverlayClick = (e) => {
        e.stopPropagation();
        const opened = this.refs.asideContent.classList.contains('opened');
        this.refs.asideContent.classList.toggle('opened', !opened);
        this.toggleDrawer(!opened);
    };
    toggleDrawer = (value) => {
        const duration = 400;
        if (value) {
            scroll.lock();
            anime({
                targets: this.refs.asideDrawer,
                translateY: ['100%', 0],
                easing: 'cubicBezier(0.645, 0.045, 0.355, 1)',
                duration
            });
        }
        else {
            anime({
                targets: this.refs.asideDrawer,
                translateY: [0, '100%'],
                easing: 'cubicBezier(0.645, 0.045, 0.355, 1)',
                duration
            }).finished.then(() => {
                scroll.unlock();
            });
        }
    };
    onSummaryButtonClick = () => {
        store.checkoutSummaryOpened.set(!store.checkoutSummaryOpened.get());
    };
    async internalRouting(pathName, xhr, requestOptions = {}) {
        this.testStep(xhr.response);
        this.modules.content.forceRouteUpdate(pathName, xhr, requestOptions);
    }
    refreshPage() {
        this.modules?.content?.refresh();
    }
    resize() {
        super.resize();
        if (!mqStore.tabletPortrait.get()) {
            this.refs.asideContent.classList.remove('opened');
            this.refs.asideDrawer.style.transform = '';
        }
    }
}
export default Returns;
